// Components/MunicipalitySelector.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const municipalityOptions = [
  'Alburquerque', 'Alicia', 'Anda', 'Antequera', 'Baclayon', 'Balilihan',
  'Batuan', 'Bien Unido', 'Bilar', 'Buenavista', 'Calape', 'Candijay',
  'Carmen', 'Catigbian', 'Clarin', 'Corella', 'Cortes', 'Dagohoy',
  'Danao', 'Dauis', 'Dimiao', 'Duero', 'Garcia Hernandez', 'Getafe',
  'Guindulman', 'Inabanga', 'Jagna', 'Lila', 'Loay', 'Loboc',
  'Loon', 'Mabini', 'Maribojoc', 'Panglao', 'Pilar', 'Sagbayan',
  'San Isidro', 'San Miguel', 'Sevilla', 'Sierra Bullones', 'Sikatuna',
  'Tagbilaran City', 'Talibon', 'Trinidad', 'Tubigon', 'Ubay', 'Valencia',
];

const MunicipalitySelector = ({ formData, setFormData, darkMode, hasError }) => {
  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (formData.municipality) {
      setSelected(formData.municipality);
      console.log('Selected Municipality:', formData.municipality); // ✅ Log is correct
    }
  }, [formData.municipality]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    setFormData(prev => ({ ...prev, municipality: value }));
  };

  return (
    <StyledSelect
      id="municipality"
      name="municipality"
      value={selected}
      onChange={handleChange}
      hasError={hasError}
    >
      <option value="">Select Municipality</option>
      {municipalityOptions.map((mun) => (
        <option key={mun} value={mun}>{mun}</option>
      ))}
    </StyledSelect>
  );
};

export default MunicipalitySelector;

// Optional styling
const StyledSelect = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${({ hasError }) => (hasError ? '#ff0000' : '#4caf50')};
  border-radius: 4px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ hasError }) => (hasError ? '#ff0000' : '#388e3c')};
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;
